// const bcn_colors =      ['#4B92C3','#FFCE3A','#96B297','#EB8032','#C0A6D8','#7FC57F','#67C4CF','#FE5BAC','#BBBB47','#F0494F']

const custom_colors = [
  '#CC0000',
  '#990000',
  '#9BC3D3',
  '#CEDEE7',
  '#444444',
  '#1BB3BC',
  '#FFCC33',
  '#9E3667',
  '#63BA68',
  '#3366FF',
  '#1C7E82',
  '#926E15',
  '#722745',
  '#3D8143',
  '#0B3CE1',
  '#7BD1D5',
  '#FDDF8A',
  '#C387A3',
  '#A2D4A6',
  '#85A5FB',
]

const low_colors = [
  '#4B92C3',
  '#FFCE3A',
  '#96B297',
  '#EB8032',
  '#C0A6D8',
  '#7FC57F',
  '#41B6C4',
  '#FE5BAC',
  '#BBBB47',
  '#F0494F',
  '#CBCBCB',
  '#B38557',
]
const low_colors_dark = [
  '#4B92C3',
  '#FFCE3A',
  '#96B297',
  '#EB8032',
  '#C0A6D8',
  '#7FC57F',
  '#41B6C4',
  '#FE5BAC',
  '#BBBB47',
  '#F0494F',
  '#CBCBCB',
  '#B38557',
]

const mid_colors = [
  '#15537E',
  '#B28707',
  '#566F57',
  '#A14300',
  '#7B6590',
  '#438043',
  '#2D7F89',
  '#7F2D56',
  '#5D5D23',
  '#A51319',
  '#858585',
  '#704820',
]
const mid_colors_dark = [
  '#15537E',
  '#B28707',
  '#566F57',
  '#A14300',
  '#7B6590',
  '#438043',
  '#2D7F89',
  '#7F2D56',
  '#5D5D23',
  '#A51319',
  '#858585',
  '#704820',
]

const high_colors = [
  '#A5C8E1',
  '#FFE69D',
  '#CAD8CB',
  '#F5BF99',
  '#DFD3EB',
  '#BFE2BF',
  '#B3E1E7',
  '#FE9CCD',
  '#E3E3B5',
  '#F7A4A7',
  '#E5E5E5',
  '#D9C2AB',
]
const high_colors_dark = [
  '#A5C8E1',
  '#FFE69D',
  '#CAD8CB',
  '#F5BF99',
  '#DFD3EB',
  '#BFE2BF',
  '#B3E1E7',
  '#FE9CCD',
  '#E3E3B5',
  '#F7A4A7',
  '#E5E5E5',
  '#D9C2AB',
]

const low_and_mid_colors = [
  '#4B92C3',
  '#15537E',
  '#FFCE3A',
  '#B28707',
  '#96B297',
  '#566F57',
  '#EB8032',
  '#A14300',
  '#C0A6D8',
  '#7B6590',
  '#7FC57F',
  '#438043',
  '#41B6C4',
  '#2D7F89',
  '#FE5BAC',
  '#7F2D56',
  '#BBBB47',
  '#5D5D23',
  '#F0494F',
  '#A51319',
  '#CBCBCB',
  '#858585',
  '#B38557',
  '#704820',
]
const low_and_mid_colors_dark = [
  '#4B92C3',
  '#15537E',
  '#FFCE3A',
  '#B28707',
  '#96B297',
  '#566F57',
  '#EB8032',
  '#A14300',
  '#C0A6D8',
  '#7B6590',
  '#7FC57F',
  '#438043',
  '#41B6C4',
  '#2D7F89',
  '#FE5BAC',
  '#7F2D56',
  '#BBBB47',
  '#5D5D23',
  '#F0494F',
  '#A51319',
  '#CBCBCB',
  '#858585',
  '#B38557',
  '#704820',
]

const low_and_mid_and_high_colors = [
  '#4B92C3',
  '#15537E',
  '#A5C8E1',
  '#FFCE3A',
  '#B28707',
  '#FFE69D',
  '#96B297',
  '#566F57',
  '#CAD8CB',
  '#EB8032',
  '#A14300',
  '#F5BF99',
  '#C0A6D8',
  '#7B6590',
  '#DFD3EB',
  '#7FC57F',
  '#438043',
  '#BFE2BF',
  '#41B6C4',
  '#2D7F89',
  '#B3E1E7',
  '#FE5BAC',
  '#7F2D56',
  '#FE9CCD',
  '#BBBB47',
  '#5D5D23',
  '#E3E3B5',
  '#F0494F',
  '#A51319',
  '#F7A4A7',
  '#CBCBCB',
  '#858585',
  '#E5E5E5',
  '#B38557',
  '#704820',
  '#D9C2AB',
]
const low_and_mid_and_high_colors_dark = [
  '#4B92C3',
  '#15537E',
  '#A5C8E1',
  '#FFCE3A',
  '#B28707',
  '#FFE69D',
  '#96B297',
  '#566F57',
  '#CAD8CB',
  '#EB8032',
  '#A14300',
  '#F5BF99',
  '#C0A6D8',
  '#7B6590',
  '#DFD3EB',
  '#7FC57F',
  '#438043',
  '#BFE2BF',
  '#41B6C4',
  '#2D7F89',
  '#B3E1E7',
  '#FE5BAC',
  '#7F2D56',
  '#FE9CCD',
  '#BBBB47',
  '#5D5D23',
  '#E3E3B5',
  '#F0494F',
  '#A51319',
  '#F7A4A7',
  '#CBCBCB',
  '#858585',
  '#E5E5E5',
  '#B38557',
  '#704820',
  '#D9C2AB',
]

const white = '#f0f0f0'
const skin_background = '#fff'
const skin_background_dark = '#1f1f1f'

const accessible_color_map_light = {
  '#1BB3BC': '#137E84',
  '#9BC3D3': '#257FA4',
  '#FFCC33': '#946F00',
  '#63BA68': '#008437',
}

const accessible_color_map_dark = {
  '#BC5478': '#C66C8D',
  '#767676': '#868686',
  '#BC4D46': '#C76B6D',
  '#8D445E': '#BB728A',
  '#4866BD': '#6D84CA',
}

export const PRIMARY_COLOR = [low_colors[0]]
export const SECONDARY_COLOR = [low_colors[1]]
export const PRIMARY_COLOR_DARK = [low_colors_dark[0]]
export const SECONDARY_COLOR_DARK = [low_colors_dark[1]]

export const PRIMARY_CAT_SCHEME = [...low_colors, ...mid_colors, ...high_colors]
export const PRIMARY_CAT_SCHEME_DARK = [...low_colors_dark, ...mid_colors_dark, ...high_colors_dark]

export const PRIMARY_CAT_SCHEME_LOW = [...low_colors]
export const PRIMARY_CAT_SCHEME_LOW_DARK = [...low_colors_dark]

export const PRIMARY_CAT_SCHEME_MID = [...low_and_mid_colors]
export const PRIMARY_CAT_SCHEME_MID_DARK = [...low_and_mid_colors_dark]

export const PRIMARY_CAT_SCHEME_HIGH = [...low_and_mid_and_high_colors]
export const PRIMARY_CAT_SCHEME_HIGH_DARK = [...low_and_mid_and_high_colors_dark]

export const PRIMARY_SEQ3_SCHEME = [white, low_colors[3], low_colors[0]]
export const PRIMARY_SEQ3_SCHEME_DARK = [white, low_colors_dark[3], low_colors_dark[0]]

export const PRIMARY_SEQ2_SCHEME = [custom_colors[3], low_colors[0]]
export const PRIMARY_SEQ2_SCHEME_DARK = [custom_colors[3], low_colors_dark[0]]

export const PRIMARY_BIN_SCHEME = [low_colors[0], low_colors[5]]
export const PRIMARY_BIN_SCHEME_DARK = [low_colors_dark[0], low_colors_dark[5]]

export const CUSTOM_COLORS = custom_colors

export const SKIN_BACKGROUND = skin_background
export const SKIN_BACKGROUND_DARK = skin_background_dark

export function mapAccessibleColor(colorCode, mode) {
  const c = colorCode.toUpperCase()
  const cmap = mode === 'light' ? accessible_color_map_light : accessible_color_map_dark
  return cmap[c] ? cmap[c] : c
}

import { rgb as d3_rgb } from 'd3-color'
export function getBrightness(color) {
  let rgb = d3_rgb(color)
  return Math.round((parseInt(rgb.r) * 299 + parseInt(rgb.g) * 587 + parseInt(rgb.b) * 114) / 1000)
}
